export function createI18nHttpClient(baseUrl) {
    const root = baseUrl.replace(/\/$/, "");
    return {
        async fetchLocales() {
            const response = await fetch(`${root}/i18n/locales`);
            if (!response.ok)
                throw new Error(`i18n locales request failed (${response.status})`);
            return (await response.json());
        },
        async fetchStatus(locale) {
            const response = await fetch(`${root}/i18n/locales/${encodeURIComponent(locale)}/status`);
            if (response.status === 404)
                return null;
            if (!response.ok)
                throw new Error(`i18n status request failed (${response.status})`);
            return (await response.json());
        },
        async fetchCatalog(locale, version) {
            const file = `${encodeURIComponent(locale)}-v${version}.json`;
            const response = await fetch(`${root}/i18n/catalogs/${file}`);
            if (response.status === 404)
                return null;
            if (!response.ok)
                throw new Error(`i18n catalog request failed (${response.status})`);
            return (await response.json());
        },
        async requestLocale(locale) {
            const response = await fetch(`${root}/i18n/locales/${encodeURIComponent(locale)}/request`, { method: "POST" });
            return { ok: response.ok };
        },
    };
}
//# sourceMappingURL=http-client.js.map